export default __webpack_public_path__ + "static/media/tata.977e67e8.webp";